import { Instance } from 'mobx-state-tree';
import { CustomerProfileLocationDtoModelBase } from './CustomerProfileLocationDtoModel.base';

/* The TypeScript type of an instance of CustomerProfileLocationDtoModel */
export interface CustomerProfileLocationDtoModelType extends Instance<typeof CustomerProfileLocationDtoModel.Type> {}

/* A graphql query fragment builders for CustomerProfileLocationDtoModel */
export { selectFromCustomerProfileLocationDto, customerProfileLocationDtoModelPrimitives, CustomerProfileLocationDtoModelSelector } from './CustomerProfileLocationDtoModel.base';

/**
 * CustomerProfileLocationDtoModel
 */
export const CustomerProfileLocationDtoModel = CustomerProfileLocationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
